<template>
    <FKBreadCrumb :page="$t('page.edit')" :title="$t('page.edit_content_category')">
        <FKBreadCrumbItem :page="$t('page.content_categories')" to="/contents" />
    </FKBreadCrumb>
    <ContentCategoryForm/> 
</template>

<script lang="ts">
import { defineComponent } from "vue";

import ContentCategoryForm from "@/components/FK/Contents/Categories/ContentCategoryForm.vue";
import KareenaContentCategoryForm from "@/components/FK/Contents/Kareena/Categories/KareenaContentCategoryForm.vue";
import FKBreadCrumb from "@/components/Widgets/BreadCrumb/FKBreadCrumb.vue";
import FKBreadCrumbItem from "@/components/Widgets/BreadCrumb/FKBreadCrumbItem.vue";
import { CLIENT, Environment } from '@/utils/const/env';

export default defineComponent({
    name: "UpdateContentCategoryPage",
    components: {
        FKBreadCrumb,
        FKBreadCrumbItem,
        ContentCategoryForm,
    },
    computed: {
        env(): Environment { return CLIENT },
    }
});
</script>